export class PermissionHandler {

  userPermissions: string[];

  constructor(userPermissions: string[]) {
    this.userPermissions = userPermissions;
  }

  public hasPermission(permission: string): boolean {
    return this.userPermissions.includes(permission);
  }
}
